import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "./components/Loader/Loader";
import Header from "./components/Header/Header.jsx";
import { SearchProvider } from "./components/SearchBar/SearchContext.js";
import ResultPage from "./pages/ResultPage/ResultPage.jsx";
import Logo from "./components/Logo/Logo.jsx";
import Footer from "./components/Footer/Footer.jsx";
import "./css/style.scss";
import BackToTop from "./components/BackToTop/BackToTop.jsx";
import { LanguageProvider } from "./context/LanguageContext.jsx";

const LazyWrapper = ({ Component }) => (
  <Suspense fallback={<Loader />}>
    <Component />
  </Suspense>
);

const Home = React.lazy(() => import("./pages/Home/Home"));
const AboutMe = React.lazy(() => import("./pages/AboutMe/AboutMe"));
const PolishCulture = React.lazy(() =>
  import("./pages/PolishCulture/PolishCulture")
);
const ForForeigners = React.lazy(() =>
  import("./pages/ForForeigners/ForForeigners")
);
const Contact = React.lazy(() => import("./pages/Contact/Contact"));
const SectionPage = React.lazy(() =>
  import("./pages/PolishCulture/SectionPage")
);

const LegendaryStories = React.lazy(() =>
  import("./pages/LegendaryStories/LegendaryStories")
);
const LegendaryStoryPage = React.lazy(() =>
  import("./pages/LegendaryStories/LegendaryStoryPage.jsx")
);

function App() {
  return (
    <LanguageProvider>
      <SearchProvider>
        <div>
          <Header />
          <Logo />
          <Routes>
            <Route path="/" element={<LazyWrapper Component={Home} />} />
            <Route path="/pl" element={<LazyWrapper Component={Home} />} />
            <Route path="/results" element={<ResultPage />} />
            <Route path="/results/pl" element={<ResultPage />} />
            <Route
              path="/about-me"
              element={<LazyWrapper Component={AboutMe} />}
            />
            <Route
              path="/about-me/pl"
              element={<LazyWrapper Component={AboutMe} />}
            />
            <Route
              path="/for-foreigners"
              element={<LazyWrapper Component={ForForeigners} />}
            />
            <Route
              path="/for-foreigners/pl"
              element={<LazyWrapper Component={ForForeigners} />}
            />
            <Route
              path="/contact"
              element={<LazyWrapper Component={Contact} />}
            />
            <Route
              path="/contact/pl"
              element={<LazyWrapper Component={Contact} />}
            />
            <Route
              path="/polish-culture"
              element={<LazyWrapper Component={PolishCulture} />}
            />
            <Route
              path="/polish-culture/pl"
              element={<LazyWrapper Component={PolishCulture} />}
            />
            <Route
              path="/polish-culture/:sectionId"
              element={<LazyWrapper Component={SectionPage} />}
            />
            <Route
              path="/polish-culture/:sectionId/pl"
              element={<LazyWrapper Component={SectionPage} />}
            />
            <Route
              path="/legendary-stories"
              element={<LazyWrapper Component={LegendaryStories} />}
            />
            <Route
              path="/legendary-stories/pl"
              element={<LazyWrapper Component={LegendaryStories} />}
            />
            <Route
              path="/legendary-stories/:sectionId"
              element={<LazyWrapper Component={LegendaryStoryPage} />}
            />
            <Route
              path="/legendary-stories/:sectionId/pl"
              element={<LazyWrapper Component={LegendaryStoryPage} />}
            />
          </Routes>
          <Footer />
          <BackToTop />
        </div>
      </SearchProvider>
    </LanguageProvider>
  );
}

export default App;